<template>
  <div class="admin-user-info-page common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Member Manage</span>
        </div>
      </div>
      <div class="content-wrap">
        <el-form class="pop-form-wrap w400" label-width="80px" :model="formData" v-if="formData" ref="commonForm">
          <el-form-item label="Name" prop="AuName">
            <el-input size="small" v-model="formData.AuName"></el-input>
          </el-form-item>
          <el-form-item label="Account" prop="AuAccount">
            <el-input size="small" v-model="formData.AuAccount" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Post" prop="AuPost">
            <el-input size="small" v-model="formData.AuPost" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Mobile" prop="AuMobile">
            <el-input size="small" v-model="formData.AuMobile"></el-input>
          </el-form-item>
          <!-- <el-form-item label="性别" prop="AuSex">
            <el-radio-group v-model="formData.AuSex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item>
            <div class="pop-center-btn-wrap">
              <el-button type="primary" @click="doUpdate('commonForm')">save</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import tools from '@/components/common/tools'

// 请求相关操作
let page = {
  methods: {
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      tools.commonAjax.call(this, true, '/SystemManage/UpdateAdminuser', data).then(() => {
        this.$message.success('Operate success!')
        // 重新获取登录用户信息
        this.$store.dispatch('getLoginMemberInfo', false)
      })
    }
  }
}

export default {
  name: 'AdminUserInfo',
  mixins: [page],
  created() {
    this.formData = tools.getModel(this.$store.state.user.memberInfo)
  },
  data() {
    return {
      formData: null
    }
  },
  methods: {
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang='scss'>
@import '~@/style/common';
</style>



// WEBPACK FOOTER //
// AdminUserInfo.vue?e24e0de6